import { AdMediaType } from '@/types';
import React, { useMemo } from 'react';
import { Picture } from '@/components/PdfManager/PdfDocument/ClassicView/Picture';
import { Title } from '@/components/PdfManager/PdfDocument/ClassicView/Section';
import { StyleSheet, View } from '@react-pdf/renderer';
import { Style } from '@react-pdf/types';
import { NewBuildingsMediaType } from '@/types/newBuildings';

export interface GallerySectionProps {
  title?: string;
  images?: AdMediaType[] | NewBuildingsMediaType[] | string[];
  wrap?: boolean;
  style?: Style;
}

const styles = StyleSheet.create({
  galleryImage: {
    objectFit: 'cover',
    borderRadius: 6,
    marginTop: 5,
  },
});

export const GallerySection = ({ title, images = [], wrap = true, style }: GallerySectionProps) => {
  if (!images.length) return null;

  const pictures = useMemo(() => {
    return images.map((img) => {
      if (typeof img === 'string') {
        return <Picture key={img} style={styles.galleryImage} src={img} />;
      }

      return <Picture key={img.id} style={styles.galleryImage} src={img.fileUrl} />;
    });
  }, [images]);

  return (
    <View wrap={wrap} style={{ marginTop: 50 }}>
      <View wrap={true}>{pictures}</View>
    </View>
  );
};
